export function formatLeaguePositionChange (value) {
  return value >= 0 ? `+${value}` : value
}



// WEBPACK FOOTER //
// ./src/utilities/index.js